export default "__VITE_PUBLIC_ASSET__3502d363__"